// actionTypes.js
export const SET_VALUE_FX_FACTURATION = "SET_VALUE_FX_FACTURATION"
export const SET_CURRENT_PAGE_FX_FACTURATION = "SET_CURRENT_PAGE_FX_FACTURATION"
export const SET_ORDER_FX_FACTURATION = "SET_ORDER_FX_FACTURATION"
export const SET_SORT_FIELD_FX_FACTURATION = "SET_SORT_FIELD_FX_FACTURATION"
export const SET_PAGE_SIZE_FX_FACTURATION = "SET_PAGE_SIZE_FX_FACTURATION"
export const SET_CUSTOM_FILTERS_FX_FACTURATION =
  "SET_CUSTOM_FILTERS_FX_FACTURATION"
export const SET_SORTING_FX_FACTURATION = "SET_SORTING_FX_FACTURATION"
export const SET_ACTIVE_TAB_FX_FACTURATION = "SET_ACTIVE_TAB_FX_FACTURATION"
export const SET_PAGE_HISTORIQUE_HM_FX_FACTURATION =
  "SET_HISTORIQUE_HM_FX_FACTURATION"
export const SET_PAGE_PAIEMENT_HM_FX_FACTURATION =
  "SET_PAIEMENT_HM_FX_FACTURATION"
export const SET_ID_FX_FACTURATION = "SET_ID_FX_FACTURATION"
export const SET_COLUMN_FX_FACTURATION = "SET_COLUMN_FX_FACTURATION"
//
export const SET_QUERY_FX_FACTURATION = "SET_QUERY_FX_FACTURATION"
export const SET_ACTIF_FX_FACTURATION = "SET_ACTIF_FX_FACTURATION"
export const SET_SELECTED_OPTION_FILTERS_FX_FACTURATION =
  "SET_SELECTED_OPTION_FILTERS_FX_FACTURATION"
export const SET_SELECTED_OPTION_ID_FX_FACTURATION =
  "SET_SELECTED_OPTION_ID_FX_FACTURATION"
